import script from "./person-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./person-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__